import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress ResizeObserver loop error - this is a known benign error that occurs
// with certain UI libraries (radix-ui, etc.) and doesn't affect functionality
const resizeObserverError = window.onerror;
window.onerror = (message, source, lineno, colno, error) => {
  if (message && message.toString().includes('ResizeObserver loop')) {
    return true; // Suppress the error
  }
  return resizeObserverError ? resizeObserverError(message, source, lineno, colno, error) : false;
};

// Also handle unhandled promise rejections for ResizeObserver
window.addEventListener('error', (e) => {
  if (e.message && e.message.includes('ResizeObserver loop')) {
    e.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
